module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-329.4bfc4c5.woff2";